import { useMutation } from 'react-query';
import { getApi } from '../../../../../config/SwaggerApi';

const addForceSyncFn = (documentLinkEntryId: string) =>
    getApi().documentLink.documentLinkForceSyncPost({ id: documentLinkEntryId })
        .then((response) => response.data);


const useAddForceSyncMutation = () => {
    const useAddForyeSyncMutation = useMutation(addForceSyncFn);

    return useAddForyeSyncMutation;
};

export default useAddForceSyncMutation;
